import { render, staticRenderFns } from "./product-demos.vue?vue&type=template&id=2546845d&"
import script from "./product-demos.vue?vue&type=script&lang=ts&"
export * from "./product-demos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./product-demos.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports